export default __webpack_public_path__ + "static/media/s2.d8a899c8.jpg";